const feeIdToContent: Map<Set<string>, string> = new Map([
    [new Set(['T-2-545701', 'T-3-545701']), 'summary_fee_NL_Calamiteitenfonds'],
    [new Set(['T-3-592580', 'T-4-592580', 'T-1-592580']), 'summary_fee_NL_SGRcontribution']
]);

export default feeIdToContent